export default function debounce(callback, wait) {
    let debounceTimer;
    let pendingCall = null;

    function debounced(...args) {
        pendingCall = { context: this, args };

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(() => {
            debounceTimer = null;
            const call = pendingCall;
            pendingCall = null;
            callback.apply(call.context, call.args);
        }, wait ?? 300);
    }

    debounced.cancel = () => {
        clearTimeout(debounceTimer);
        debounceTimer = null;
        pendingCall = null;
    };

    debounced.flush = () => {
        if (!debounceTimer) {
            return;
        }
        clearTimeout(debounceTimer);
        debounceTimer = null;
        const call = pendingCall;
        pendingCall = null;
        callback.apply(call.context, call.args);
    };

    return debounced;
}
